const allCodes = require('../../libs/full-zipcodes.json');

export const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE','DC' ,'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

export const whichStates = (zipcode) => {
  const firstDigit = zipcode[0];
  switch (firstDigit) {
    case '0':
      return ['CT', 'MA', 'ME', 'NH', 'NJ', 'RI', 'VT'];
    case '1':
      return ['DE', 'NY', 'PA'];
    case '2':
      return ['MD', 'NC', 'SC', 'VA', 'WV'];
    case '3':
      return ['AL', 'FL', 'GA', 'MS', 'TN'];
    case '4':
      return ['IN', 'KY', 'MI', 'OH'];
    case '5':
      return ['IA', 'MN', 'MT', 'ND', 'SD', 'WI'];
    case '6':
      return ['IL', 'KS', 'MO', 'NE'];
    case '7':
      return ['AR', 'LA', 'OK', 'TX'];
    case '8':
      return ['AZ', 'CO', 'ID', 'NM', 'NV', 'UT', 'WY'];
    case '9':
      return ['AK', 'CA', 'HI', 'OR', 'WA'];
    default:
      return [];
  }
};

export const getZipCodes = (state) => allCodes[state] || [];

export const selectMsgTitle = (state) => state.auth.msgTitle;
export const selectMsgText = (state) => state.auth.msgText;

const extensionPattern = /\.[0-9a-z]+$/i;
export const generateUniqueFileName = (fileName) => {
  const matched = fileName.match(extensionPattern);
  const extension = matched[0];
  const idx = matched['index'];
  const baseName = fileName.substring(0, idx);
  return `${baseName}_${crypto.randomUUID().slice(0, 8)}${extension}`;
};
